import styles from './card.module.css';

export const Card = ({ children }) => <div className={`${styles.card}`}>{children}</div>;

export const CardBody = ({ children }) => <div className={`${styles.cardBody}`}>{children}</div>;